import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    InputBase,
    Paper,
    Tooltip,
    Typography
} from '@mui/material';
import React, { useState } from 'react'
import SendIcon from '@mui/icons-material/Send';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useNavigate } from 'react-router-dom';
import logoempresa from '../../../media/logoempresa.png';
import { convertirEnlaces } from '../../../utils/utils';

export const ChatInterno = ({ comentariosInternos, enviarComentario, mensajeInterno, handleInputChangeInterno, handleKeyPress, enviarComentarioInterno, puedeEliminarComentarios, eliminarComentarioInterno }) => {
    const navigate = useNavigate();
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
    const [comentarioAEliminar, setComentarioAEliminar] = useState(null);

    const abrirConfirmacionEliminar = (comentario) => {
        setComentarioAEliminar(comentario);
        setOpenConfirmDelete(true);
    };

    const cerrarConfirmacionEliminar = () => {
        setOpenConfirmDelete(false);
        setComentarioAEliminar(null);
    };

    const confirmarEliminarComentario = () => {
        if (!comentarioAEliminar?.id) return;

        eliminarComentarioInterno(comentarioAEliminar.id);
        cerrarConfirmacionEliminar();
    };


    return (
        <>
            <div className='envase-chat-interno'>
                <Grid container xs={12} direction={'row'} justifyContent={'space-between'} >
                    <strong>&nbsp;Comentarios Internos:</strong>
                    <img src={logoempresa} alt="Logo" className="logo-chat" onClick={() => navigate('/')} />
                </Grid>

                <div className='contenedor-chat' style={{ minHeight: '22vh', maxHeight: '22vh', overflow: 'auto' }}>
                    {comentariosInternos.map((comentario => (
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            xs={8}
                            className={`bocadillo-chat ${comentario.autor == 1 ? 'autor' : ''}`}
                            key={comentario.id}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="space-between"
                                alignItems="start"
                                xs={12}
                            >
                                <Typography variant='subtitle1' sx={{ color: comentario.color, textAlign: 'left' }} >
                                    <strong>{comentario.nombre}</strong>
                                </Typography>
                                {puedeEliminarComentarios && comentario.id && (
                                    <Tooltip title="Eliminar comentario" arrow>
                                        <IconButton
                                            size="small"
                                            color="error"
                                            onClick={() => abrirConfirmacionEliminar(comentario)}
                                        >
                                            <DeleteForeverIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </Grid>
                            <Grid
                                container
                                direction="row"
                                justifyContent="start"
                                alignItems="start"
                                xs={12}
                            >
                                <Typography variant='body2' className='texto-con-salto'>
                                    {convertirEnlaces(comentario.comentario)}
                                </Typography>
                            </Grid>
                            <Grid
                                container
                                direction="row"
                                justifyContent="end"
                                alignItems="end"
                                xs={12}
                            >
                                <Typography variant='caption'>
                                    <strong>{comentario.fecha}</strong>
                                </Typography>
                            </Grid>
                        </Grid>
                    )))}

                </div>
                <Grid xs={12} className='chat-bar'>
                    <Paper
                        component="form"
                        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%', backgroundColor: '#e1e0e0' }}
                        variant='outlined'
                        onSubmit={(e) => { e.preventDefault(); enviarComentario(); }}
                    >
                        <InputBase
                            sx={{ ml: 1, flex: 1 }}
                            placeholder="Escribe un mensaje nuevo"
                            inputProps={{ 'aria-label': 'Escribe un mensaje nuevo' }}
                            name='mensajeInterno'
                            value={mensajeInterno}
                            onChange={handleInputChangeInterno}
                            onKeyPress={handleKeyPress}
                        />
                        <IconButton type="button" sx={{ p: '10px' }} aria-label="send" >
                            <SendIcon onClick={() => enviarComentarioInterno()} />
                        </IconButton>
                    </Paper>
                </Grid>
            </div>

            <Dialog
                open={openConfirmDelete}
                onClose={cerrarConfirmacionEliminar}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>
                    Eliminar comentario
                </DialogTitle>

                <DialogContent>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                        ¿Seguro que quieres eliminar este comentario?
                    </Typography>

                    {comentarioAEliminar?.comentario && (
                        <Typography
                            variant="body2"
                            sx={{
                                p: 1.5,
                                backgroundColor: '#f5f5f5',
                                borderRadius: 1,
                                maxHeight: 120,
                                overflow: 'auto'
                            }}
                        >
                            {comentarioAEliminar.comentario}
                        </Typography>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={cerrarConfirmacionEliminar}
                    >
                        Cancelar
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        onClick={confirmarEliminarComentario}
                    >
                        Eliminar
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    )
}
